import React, { useState, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import FRONTEND_CONFIG from "./frontend_config";

const ResultPage = () => {
  const [applicationId, setApplicationId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  const resultRef = useRef(); // Reference for printing & PDF

  const handleSearch = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    

    try {
      const response = await fetch(
        `${FRONTEND_CONFIG.API_URL}/api/responses/result/${applicationId}`
      );

      if (!response.ok) {
        setError("❌ Result not found. Check Application ID.");
        setLoading(false);
        return;
      }

      const data = await response.json();
      setResult(data);
    } catch (err) {
      setError("❌ Server error. Try again later.");
    }

    setLoading(false);
  };

  /** 🖨 Print Result */
  const handlePrint = () => {
    window.print();
  };

  /** 📄 Download PDF */
  const handlePDFDownload = async () => {
    const input = resultRef.current;

    const canvas = await html2canvas(input);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const width = pdf.internal.pageSize.getWidth();
    const height = (canvas.height * width) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, width, height);
    pdf.save(`${result.studentName}_Result.pdf`);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.heading}>📄 Check Your Result</h2>

        {/* Search Form */}
        <form onSubmit={handleSearch} style={styles.form}>
          <input
            type="text"
            placeholder="Enter Application ID"
            value={applicationId}
            onChange={(e) => setApplicationId(e.target.value)}
            required
            style={styles.input}
          />
          <button type="submit" style={styles.button}>
            {loading ? "Checking..." : "View Result"}
          </button>
        </form>

        {error && <p style={styles.error}>{error}</p>}

        {/* Result */}
        {result && (
          <>
            <div style={styles.resultBox} ref={resultRef}>
              <h3 style={styles.certificateTitle}>🏅 ACHIEVEMENT CERTIFICATE</h3>
              <p style={{ textAlign: "center" }}>
                This is to certify that <strong>{result.studentName}</strong> has successfully
                appeared for the <strong>{result.examName}</strong> and achieved:
              </p>

              <h3 style={{ ...styles.scoreText, fontSize: "20px", marginBottom: "10px" }}>
  Total Marks
</h3>

<h2 style={styles.scoreText}>
  {result.obtainedMarks} / {result.totalMarks}
</h2>



              <hr />
              <p><strong>Application ID:</strong> {result.applicationId}</p>
              <p><strong>Exam ID:</strong> {result.examId}</p>
              <p><strong>Exam Name:</strong> {result.examName}</p>
              <p><strong>Question Set:</strong> {result.questionSetName}</p>

              <p><strong>Correct:</strong> {result.correct}</p>
              <p><strong>Wrong:</strong> {result.wrong}</p>
              <p><strong>Total Questions:</strong> {result.totalQuestions}</p>
            </div>

            {/* Action Buttons */}
            <div style={styles.buttonSection}>
              <button style={styles.printBtn} onClick={handlePrint}>🖨 Print</button>
              <button style={styles.pdfBtn} onClick={handlePDFDownload}>📄 Download PDF</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ResultPage;


// -----------------------
// Inline Styling
// -----------------------
const styles = {
  container: {
    width: "100%",
    height: "100vh",
    background: "#ffffff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "15px",
  },
  card: {
    width: "520px",
    background: "rgba(255,255,255,0.9)",
    padding: "35px",
    borderRadius: "15px",
    boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
  },
  heading: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "28px",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    gap: "10px",
  },
  input: {
    flex: 1,
    padding: "12px",
    border: "1px solid #bbb",
    borderRadius: "10px",
    fontSize: "16px",
  },
  button: {
    padding: "12px 18px",
    background: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    fontSize: "16px",
  },
  error: {
    marginTop: "15px",
    color: "red",
    fontWeight: "bold",
    textAlign: "center",
  },
  resultBox: {
    marginTop: "20px",
    background: "#ffffff",
    padding: "20px",
    borderRadius: "12px",
    lineHeight: "1.7",
    border: "3px solid gold",
    textAlign: "left",
  },
  certificateTitle: {
    textAlign: "center",
    fontSize: "22px",
    fontWeight: "bold",
    color: "goldenrod",
  },
  scoreText: {
    textAlign: "center",
    fontSize: "32px",
    fontWeight: "bold",
    color: "green",
    margin: "10px 0",
  },
  buttonSection: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "space-around",
  },
  printBtn: {
    padding: "10px 18px",
    background: "#28a745",
    color: "white",
    borderRadius: "10px",
    cursor: "pointer",
  },
  pdfBtn: {
    padding: "10px 18px",
    background: "#dc3545",
    color: "white",
    borderRadius: "10px",
    cursor: "pointer",
  },
};
